import React from "react";
import { Helmet } from "react-helmet";
import "../styles/subpages.css";

const PrivacyPolicy = () => {
  return (
    <section id="privacy" className="privacy-section">
      <Helmet>
        <title>Adatvédelmi tájékoztató – Olajcsere Szolnokon</title>
        <meta
          name="description"
          content="Az olajcsereszolnok.hu adatvédelmi tájékoztatója. Részletek a kezelt adatokról, jogalapokról, adatmegőrzési időkről és a felhasználók jogairól a GDPR és az Info tv. alapján."
        />
        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://olajcsereszolnok.hu/adatvedelmi-tajekoztato"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Adatvédelmi tájékoztató – Olajcsere Szolnokon"
        />
        <meta
          property="og:description"
          content="Olajcsereszolnok.hu adatvédelmi és GDPR tájékoztató. Részletek a kezelt adatokról, jogorvoslati lehetőségekről és sütikezelésről."
        />
        <meta
          property="og:url"
          content="https://olajcsereszolnok.hu/adatvedelmi-tajekoztato"
        />
        <meta
          property="og:image"
          content="https://olajcsereszolnok.hu/og.png"
        />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Adatvédelmi tájékoztató – Olajcsere Szolnokon"
        />
        <meta
          name="twitter:description"
          content="Olajcsereszolnok.hu adatvédelmi és GDPR tájékoztató. Jogok, adatkezelés és sütik részletesen."
        />
        <meta
          name="twitter:image"
          content="https://olajcsereszolnok.hu/og.png"
        />
      </Helmet>

      <div className="privacy-policy container mt-5 py-5 text-center d-flex flex-column align-items-center">
        <h1 className="mb-4 pt-5">Adatvédelmi tájékoztató</h1>

        <p className="w-100">
          Jelen adatvédelmi tájékoztató célja, hogy rögzítse az
          olajcsereszolnok.hu weboldalon keresztül megvalósuló adatkezelés
          körülményeit, figyelembe véve az Európai Parlament és a Tanács (EU)
          2016/679 rendeletében (GDPR) és a 2011. évi CXII. törvényben (Info
          tv.) foglaltakat.
        </p>

        <div className="subpage-card">
          <h3>1. Adatkezelő adatai</h3>
          <p>
            <strong>Cégnév:</strong> Ratkai Technologies Kft. <br />
            <strong>Székhely:</strong> 5000 Szolnok, Rezeda utca 8.
            <br />
            <strong>Adószám:</strong> 24288503-2-16
          </p>

          <h3>2. Kezelt adatok köre</h3>
          <p>
            Az oldalon található kapcsolatfelvételi űrlapon keresztül az alábbi
            személyes adatokat kezeljük:
          </p>
          <ul className="list-unstyled">
            <li>Név</li>
            <li>Telefonszám</li>
            <li>E-mail cím</li>
            <li>Üzenet tartalma</li>
          </ul>

          <h3>3. Adatkezelés célja és jogalapja</h3>
          <p>
            Az adatkezelés célja a felhasználó megkeresésének megválaszolása,
            kapcsolattartás. Az adatkezelés jogalapja: GDPR 6. cikk (1) bek. a)
            pont (érintett hozzájárulása).
          </p>

          <h3>4. Az adatok megőrzésének időtartama</h3>
          <p>
            A beküldött adatokat az adatkezelő az ügy lezárását követően
            legfeljebb 90 napig tárolja, kivéve, ha jogszabály hosszabb
            megőrzést ír elő.
          </p>

          <h3>5. Adattovábbítás, adatfeldolgozók</h3>
          <p>
            Az Ön adatait harmadik fél részére nem továbbítjuk. A rendszer
            működtetéséhez igénybe vett tárhelyszolgáltató technikai
            adatfeldolgozónak minősül:
          </p>
          <p>
            <strong>Szolgáltató:</strong> Amazon Web Services (AWS) <br />
            <strong>Székhely:</strong> Seattle, WA, USA <br />
            <strong>Adatfeldolgozás:</strong> Szerver- és adatbiztonsági
            szolgáltatás
          </p>

          <h3>6. Az érintettek jogai</h3>
          <ul className="list-unstyled">
            <li>Tájékoztatáshoz való jog</li>
            <li>Hozzáféréshez való jog</li>
            <li>Helyesbítéshez való jog</li>
            <li>Törléshez való jog („az elfeledtetéshez való jog”)</li>
            <li>Adatkezelés korlátozásához való jog</li>
            <li>Adathordozhatósághoz való jog</li>
            <li>Tiltakozás az adatkezelés ellen</li>
          </ul>

          <h3>7. Jogorvoslati lehetőségek</h3>
          <p>
            Amennyiben úgy érzi, hogy adatkezelésünk jogsértő, kérjük, először
            vegye fel velünk a kapcsolatot. Továbbá Ön jogosult panasszal élni a
            Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH):
          </p>
          <p>
            <strong>NAIH</strong> <br />
            Cím: 1055 Budapest, Falk Miksa utca 9-11. <br />
            Telefon: +36 (1) 391-1400 <br />
            Web:{" "}
            <a href="https://www.naih.hu" target="_blank" rel="noreferrer">
              www.naih.hu
            </a>
          </p>

          <h3>8. Sütik (cookie-k) kezelése</h3>
          <p>
            A weboldal működéséhez szükséges sütiket alkalmazunk. A sütik
            elhelyezése a látogató hozzájárulásával történik, amelyet a
            megjelenő cookie banner segítségével adhat meg vagy utasíthat
            vissza.
          </p>

          <h3>9. Záró rendelkezések</h3>
          <p>
            Az Adatkezelő fenntartja a jogot a tájékoztató módosítására. A
            változásokról a weboldalon keresztül értesítjük a felhasználókat.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
